import React, { Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Products from './components/products/Products';
import store from '../cart/services/store';
import setSortValue from './services/set_sort_value';
import { productsActions } from './actions';

const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));

window.store = window.store || store;

document.addEventListener('DOMContentLoaded', () => {
  const elementId = 'react-products';
  const container = document.getElementById(elementId);
  const data = JSON.parse(document.querySelector(`script[data-dom-id="${elementId}"]`).textContent);
  const { products, productsPerPage, showSkinType } = data;

  window.store.dispatch(productsActions.addProducts(products));

  hydrateRoot(
    container,
    <Provider store={window.store}>
      <Products productsPerPage={productsPerPage} showSkinType={showSkinType} />
    </Provider>,
  );

  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );

  AOS.init();

  setSortValue();
});
